import styled from '@emotion/styled';

export const Wrapper = styled.span`
    color: ${({ theme }) => theme.colors.warning};
    font-size: .8rem;
`;
